import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const mobile = '@media (max-width: 768px)'

const flexRow = css`
  display: flex;
`

const flexCol = css`
  ${flexRow};
  flex-direction: column;
`

const centerCol = css`
  ${flexCol};
  justify-content: center;
`

const textSegoe = css`
  font-family: 'Segoe UI', Arial;
`

const rowBase = css`
  ${flexRow};
  gap: 20px;

  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  p {
    font-size: 18px;
    line-height: 26px;
  }

  ${mobile} {
    flex-direction: column;
  }
`

const colBase = css`
  border-radius: 15px;
  padding: 20px 30px;

  ${centerCol};

  ${mobile} {
    padding: 20px;
  }
`

export const Container = styled.section`
  width: 1180px;
  margin: 0 auto;
  padding: 80px 10px 0;
  position: relative;

  ${mobile} {
    width: 100%;
    padding: 40px 20px 0;
  }
`

export const Wrapper = styled.div``

export const Content = styled.div`
  position: relative;

  h3 {
    font-weight: bold;
    font-size: 22px;
  }
`

export const Bg = styled.div`
  position: absolute;
  bottom: -25px;
  right: -70px;

  ${mobile} {
    display: none;
  }
`

export const Title = styled.h2`
  font-size: 35px;
  ${textSegoe};
  font-weight: 400;
  color: #78be20;
  display: flex;

  span {
    font-weight: 800;
    margin-right: 10px;
  }

  ${mobile} {
    font-size: 28px;
    flex-wrap: wrap;
  }
`

export const Subtitle = styled.div`
  ${flexRow};
  align-items: center;
  gap: 15px;
  margin: 20px 0;

  ${mobile} {
    ${flexCol};
    align-items: flex-start;
    gap: 10px;
  }
`

export const Row = styled.div`
  ${rowBase};
  margin-bottom: 8px;
`

export const Row2 = styled.div`
  ${rowBase};
  padding-bottom: 10px;
`

export const Column = styled.div`
  ${colBase};
  background: #eeeef0;
`

export const Column1 = styled.div`
  ${colBase};
  background: #eeeef0;
  width: 450px;

  ${mobile} {
    width: 100%;
  }
`

export const Column2 = styled.div`
  ${colBase};
  border: 1px solid #eeeef0;
  width: 700px;

  ul {
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 1.5em;
    font-size: 18px;
    line-height: 26px;
  }

  ${mobile} {
    width: 100%;
  }
`
